import {UseQueryResult} from '@tanstack/react-query';
import {createContext, useContext} from 'react';
import {MaibCardItem, MaibCardsType} from 'types';

export interface CardPaymentContextType {
  cardQuery: UseQueryResult<MaibCardsType, unknown>;
  onChangeCard: (card?: MaibCardItem) => void;
  onRemoveCard: (id: number) => void;
  onAddNewCard: () => void;

  selectedCard: MaibCardItem | undefined;
  onOpenCardsModal: () => void;
}

export const CardPaymentContext = createContext<CardPaymentContextType | undefined>(undefined);

export const useCardPayment = (): CardPaymentContextType => {
  const context = useContext(CardPaymentContext);
  if (!context) throw new Error('useCardPayment must be used within a CardPaymentProvider');

  return context;
};
